export class AuthConstants {
  public static ROLES = {
    Developer: {
      name: 'Developer'
    },
    Admin: {
      name: 'Admin'
    },
    AssetManagement: {
      name: 'AssetManagement'
    },
    CapitalForecasting: {
      name: 'CapitalForecasting'
    },
    ProductionEconomics: {
      name: 'ProductionEconomics'
    },
    Projects: {
      name: 'Projects'
    },
    Reporting: {
      name: 'Reporting'
    },
    ScheduleManagement: {
      name: 'ScheduleManagement'
    }
  }
}